export default __webpack_public_path__ + "0288b8e442c5b8d5e2a68edb0a8dbcbd.gif";